import React from 'react';
import ReactDOM from 'react-dom';
import styles from '../Onboarding.module.css';
import * as utils from '../../../utils/utils';
import HQDialog from '../../HQDialog/HQDialog';
import { FiPlus } from 'react-icons/fi';

export default class OnboardingOffers extends React.Component {

    constructor(props) {
        super(props);

        this.screens = {
            Info: 1,
            Offers: 2,
        };
        
        this.state = {
            currentScreen: this.screens.Info,
            offerItems: [''],
            activeOfferIndex: 0,
            isSavingOffers: false,

            showSkipOffers: false,

            errorText: '',
        };
    };

    componentDidMount() {
        if (!utils.isLoggedIn()) {
            window.location.href = '/signin';
            return;
        }
    };

    componentWillUnmount() {
    };

    getErrorMessage = (error, fallbackText) => {
        if (error && typeof error === 'object' && typeof error.message === 'string' && error.message.trim() !== '') {
            return error.message;
        }

        if (typeof error === 'string' && error.trim() !== '') {
            return error;
        }

        return fallbackText;
    };

    onListItemChange = (index, value) => {
        const {
            offerItems,
        } = this.state;

        offerItems[index] = value;

        this.setState({
            offerItems,
            errorText: '',
        });
    };

    getExampleTargetIndex = (items, activeIndex) => {
        if (Number.isInteger(activeIndex) && activeIndex >= 0 && activeIndex < items.length) {
            return activeIndex;
        }

        const emptyIndex = items.findIndex((item) => item.trim() === '');

        if (emptyIndex >= 0) {
            return emptyIndex;
        }

        return 0;
    };

    applyExampleText = (text) => {
        const { offerItems, activeOfferIndex } = this.state;

        const nextIndex = this.getExampleTargetIndex(offerItems, activeOfferIndex);
        this.setState((prevState) => {
            const nextItems = [...prevState.offerItems];
            nextItems[nextIndex] = text;

            return {
                offerItems: nextItems,
                activeOfferIndex: nextIndex,
                errorText: '',
            };
        });
    };

    addItem = () => {
        this.setState((prevState) => {
            const nextItems = [...prevState.offerItems];

            if (nextItems.length < 5) {
                nextItems.push('');
            }

            return {
                offerItems: nextItems,
                errorText: '',
            };
        });
    };

    getSanitizedItems = (items) => {
        if (!Array.isArray(items)) {
            return [];
        }

        return items
            .map((item) => (typeof item === 'string' ? item.trim() : ''))
            .filter((item) => item !== '');
    };

    saveOffersAndContinue = async () => {
        if (this.state.isSavingOffers) {
            return;
        }

        const offerTexts = this.getSanitizedItems(this.state.offerItems);

        if (offerTexts.length === 0) {
            this.setState({ errorText: 'Please add at least one offer item, or skip this step.' });
            return;
        }

        this.setState({
            isSavingOffers: true,
            errorText: '',
        });

        try {
            await utils.sendRequest('/offer/saveOffer', {
                offerTexts,
            });

            this.setState({
                isSavingOffers: false,
                errorText: '',
            }, this.props.onContinue);
        }
        catch (error) {
            console.log('save offer error', error);
            this.setState({
                isSavingOffers: false,
                errorText: this.getErrorMessage(error, 'Could not save offers. Please try again.'),
            });
        }
    };

    renderExamples = (items) => {
        return (
            <div className={styles.examplesBox}>
                <p className={styles.examplesTitle}>Examples</p>
                <div className={styles.exampleList}>
                    {items.map((item, index) => (
                        <button
                            key={index}
                            type='button'
                            className={styles.exampleButton}
                            onClick={() => this.applyExampleText(item)}
                        >
                            {item}
                        </button>
                    ))}
                </div>
            </div>
        );
    };

    showSkipOffers = () => {
        this.setState({
            showSkipOffers: true,
        });
    };

    renderSkipOffersDialog = () => {
        const dialogNode = (
            this.state.showSkipOffers &&
            <HQDialog
                title="Skip Offers"
                message="Are you sure you want to skip this step? Setting your offers helps us match you with relevant opportunities and people. You can always set your offers later."
                primaryButtonText="Skip"
                onPrimaryClick={this.skipOffers}
                onCancelClick={() => this.setState({ showSkipOffers: false })}
            />
        );

        const portalNode = typeof this.props.getDialogPortalNode === 'function'
            ? this.props.getDialogPortalNode()
            : this.props.dialogPortalNode;

        if (portalNode) {
            return ReactDOM.createPortal(dialogNode, portalNode);
        }

        return dialogNode;
    };

    skipOffers = () => {
        this.setState({
            showSkipOffers: false,
            errorText: '',
        }, this.props.onSkip);
    };


    renderInfoScreen = () => {
        return (
            <>
                <h2 className={styles.formMainTitle}>Offers</h2>
                <p className={styles.formMainText}>Lastly, describe what you can offer to others on HQ: services, mentorship, what kind of help you can offer. This will help us intro you the right people.</p>

                <button
                    className={styles.primaryButton}
                    type='button'
                    onClick={() => this.setState({ currentScreen: this.screens.Offers })}
                >
                    Continue
                </button>
            </>
        );
    };

    renderOffersScreen = () => {
        const {
            offerItems,
            isSavingOffers,
            errorText,
        } = this.state;

        return (
            <>

                <h2 className={styles.formTitle}>What you can offer</h2>
                <p className={styles.formText}>Briefly describe what you offer: services, mentorship, what kind of help you can offer</p>

                {
                    this.renderExamples([
                        'I can help with product design and UX.',
                        'I can help with fundraising and investor introductions.',
                        'I can help with marketing and growth strategy.',
                        'I can help with hiring and team building.',
                        'I can help with business strategy and operations.',
                    ])
                }
                <div className={styles.form}>
                    {offerItems.map((item, index) => (
                        <div key={`offerItems-${index}`} className={styles.fieldGroup}>
                            <label className={styles.label} htmlFor={`offerItems-item-${index + 1}`}>Item {index + 1}</label>
                            <input
                                type='text'
                                id={`offerItems-item-${index + 1}`}
                                rows={3}
                                className={styles.textInput}
                                placeholder='Describe what services, help, or mentorship you can offer.'
                                value={item}
                                onChange={(event) => this.onListItemChange(index, event.target.value)}
                                onFocus={() => this.setState({ activeOfferIndex: index })}
                                disabled={isSavingOffers}
                            />
                        </div>
                    ))}

                    {
                        offerItems.length < 5 &&
                        <button
                            className={styles.secondaryButton}
                            type='button'
                            onClick={this.addItem}
                            disabled={isSavingOffers}
                        >
                            <FiPlus /> Add Item
                        </button>
                    }

                    <div className={styles.actionRow}>
                        <span className={styles.helperText}>{offerItems.length}/5 items</span>
                    </div>

                    <button
                        className={styles.primaryButton}
                        type='button'
                        onClick={this.saveOffersAndContinue}
                        disabled={isSavingOffers}
                    >
                        {isSavingOffers ? 'Saving...' : 'Save & Continue'}
                    </button>

                    <button
                        className={styles.secondaryButton}
                        type='button'
                        onClick={this.skipOffers}
                        disabled={isSavingOffers}
                    >
                        Skip
                    </button>
                </div>

                {
                    errorText !== '' &&
                    <div className={styles.errorBox}>{errorText}</div>
                }

                {this.renderSkipOffersDialog()}
            </>
        );
    };

    renderCurrentScreen = () => {
        const {
            currentScreen,
        } = this.state;

        if (currentScreen === this.screens.Info) {
            return this.renderInfoScreen();
        }
        else if (currentScreen === this.screens.Offers) {
            return this.renderOffersScreen();
        }
    };

    render() {
        return this.renderCurrentScreen();
    };


}
